import axios from 'axios';
import api from '@/services/api';
import { MAIN_APP_API_URL } from '@/types';

const DEV_SSO_SECRET = import.meta.env.VITE_SSO_SERVICE_SECRET as string | undefined;

const inflightByCode = new Map<string, Promise<void>>();

export async function setSessionFromToken(token: string, signal?: AbortSignal): Promise<void> {
  await api.post('/auth/session-from-token', { token }, { timeout: 10000, signal });
}

/** Local dev fallback: exchange one-time code via hkhbref API. */
async function exchangeViaMainApi(code: string, signal?: AbortSignal): Promise<void> {
  if (!DEV_SSO_SECRET) {
    throw new Error('VITE_SSO_SERVICE_SECRET 未設定');
  }

  const { data } = await axios.post<{ token: string; user: unknown }>(
    `${MAIN_APP_API_URL}/auth/sso-exchange`,
    { code },
    {
      headers: { 'X-SSO-Secret': DEV_SSO_SECRET },
      timeout: 10000,
      signal,
    }
  );

  if (!data.token) {
    throw new Error('主系統未回傳 token');
  }

  await setSessionFromToken(data.token, signal);
}

/** Production: Worker calls hkhbref and sets cookie. */
async function exchangeViaWorker(code: string, signal?: AbortSignal): Promise<void> {
  await api.post('/auth/exchange', { code }, { timeout: 30000, signal });
}

export async function exchangeSsoCode(code: string, signal?: AbortSignal): Promise<void> {
  const existing = inflightByCode.get(code);
  if (existing) return existing;

  const run = (async () => {
    if (import.meta.env.DEV) {
      await exchangeViaMainApi(code, signal);
      return;
    }
    await exchangeViaWorker(code, signal);
  })().finally(() => {
    inflightByCode.delete(code);
  });

  inflightByCode.set(code, run);
  return run;
}
